import { ChangeDetectorRef, Component, ElementRef, ErrorHandler, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy, Injector, inject, signal } from '@angular/core'
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { FieldTree, form, pattern, required } from '@angular/forms/signals'
import { MatInput } from '@angular/material/input'
import { ActivatedRoute, Data, Router } from '@angular/router'

import { arvonMuutokset, asetaArvo, nollaa } from '../../_jaettu-angular/_lomakkeet/arvon-muutokset'
import { validoiReaktiivisesti } from '../../_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { FormValidationService } from '../../_jaettu-angular/service/form-validation.service'
import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'

import { firstValueFrom, Observable, Subject } from 'rxjs'
import { map, takeUntil } from 'rxjs/operators'

import { kaikkiNakymatRecord, LEMONATOR_NAKYMAT, LemonatorNakymaRyhma, LemonatorNakymaTieto } from '../../_angular/service/nakyma-oikeus.service'
import {
  KatkaiseKirjanpitajanSessioPyynto,
  KatkaiseKirjanpitajanSessioVastaus,
  Kirjanpitaja,
  KirjanpitajanKuvanUploadRequest,
  KirjanpitajanKuvanUploadResponse,
  KirjanpitajanToimipiste,
} from '../../_jaettu-lemonator/model/kirjanpitaja'
import { LemonatorNakyma } from '../../_jaettu-lemonator/model/lemonator-nakyma'

import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { KirjanpitajanRooli } from '@lemon/core-firebase/lemonator/model/kirjanpitaja'
import { KirjanpitajienRoolitUriService } from '@lemon/core-firebase/lemonator/service/kirjanpitajien-roolit-uri.service'
import { DateService } from '@lemon/core/service/date.service'
import {
  KirjanpitajienRooliKonfiguraatio,
  TallennaKirjanpitajanRooliPyynto,
  TallennaKirjanpitajanRooliVastaus,
} from '@lemon/lemonaid-lemonator-functions-and-lemonator-angular/model/kirjanpitajien-roolit'
import { DebugService } from 'app/_angular/service/debug.service'
import { FirebaseLemonaid, FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { DragAndDropService } from 'app/_jaettu-angular/service/drag-and-drop.service'
import { TiedostojenLataamisService, UploadData } from 'app/_jaettu-angular/service/tiedostojen-lataamis.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { KirjanpitajanToimipisteService } from 'app/_jaettu-lemonator/service/kirjanpitajan-toimipiste.service'
import { KirjanpitajaComponentData } from '../../_angular/_resolvers/kirjanpitaja.resolve'
import { KirjanpitajaKopioija } from '../../_angular/service/kirjanpitaja/kirjanpitaja.kopioija'
import { KirjanpitajaService } from '../../_angular/service/kirjanpitaja/kirjanpitaja.service'
import { AreYouSureDialog, AreYouSureDialogData } from '../../_jaettu-angular/_components/are-you-sure.dialog'
import { FileSystemFileEntry } from '../../_jaettu-angular/file-drop/file-drop-dom.types'
import { FileDropEntry } from '../../_jaettu-angular/file-drop/file-drop-entry'

interface KirjanpitajaLomake {
  etunimi: string
  sukunimi: string
  email: string
  puhelin: string
  aloitti: Date | null
  toimipiste: string | null
  tutkintoKlt: boolean | null
  aktiivinen: boolean | null
  rooli: KirjanpitajanRooli | null
}

const TYHJA_LOMAKE: KirjanpitajaLomake = { etunimi: '', sukunimi: '', email: '', puhelin: '', aloitti: null, toimipiste: null, tutkintoKlt: null, aktiivinen: null, rooli: null }

@Component({
  templateUrl: './kirjanpitaja.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjanpitajaComponent implements OnInit, OnDestroy {
  @ViewChild(MatInput, { static: true }) etunimiInput: MatInput
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef

  private _ngUnsubscribe: Subject<void> = new Subject<void>()

  loading: boolean = false
  isDragging: boolean = false
  kuvanVirhe = ''
  namename = 'asdf ' + Math.random()
  donePercentageObservable: Observable<number>
  driverObservable: Observable<any>
  uploadTasks: UploadData

  kirjanpitajaUriObservable: Observable<string>
  kirjanpitajaEncodedUriObservable: Observable<string>
  kirjanpitajaOnDevaajaObservable: Observable<boolean>
  kirjanpitajaOnDevaajaTaiTukiObservable: Observable<boolean>

  lomake: FieldTree<KirjanpitajaLomake>
  private readonly _injector = inject(Injector)

  readonly commonError = signal<string | null>(null)
  kirjanpitaja: Kirjanpitaja
  kaikkiToimipisteet: KirjanpitajanToimipiste[] = []
  nakymaRyhmat: { ryhma: string; nakymat: LemonatorNakymaTieto[] }[] = []

  // KirjanpitajanRooli-enumi templaattia varten
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly KirjanpitajanRooli = KirjanpitajanRooli

  constructor(
    private _errorHandler: ErrorHandler,
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _route: ActivatedRoute,
    private _kirjanpitajaService: KirjanpitajaService,
    private _kirjanpitajaKopioija: KirjanpitajaKopioija,
    private _validationService: FormValidationService,
    private _ladataanService: LadataanService,
    private _dateService: DateService,
    private _dndService: DragAndDropService,
    private _firebase: FirebaseLemonator,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _tiedostojenLataamisService: TiedostojenLataamisService,
    private _snackbar: MatSnackBar,
    private _kirjanpitajanToimipisteService: KirjanpitajanToimipisteService,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _timestampService: TimestampService,
    private _debugService: DebugService,
    private _dialog: MatDialog,
    private _roolitUriService: KirjanpitajienRoolitUriService,
  ) {
    this.kirjanpitaja = this._kirjanpitajaKopioija.annaUusiKirjanpitaja()

    const ryhmaMap = new Map<LemonatorNakymaRyhma, LemonatorNakymaTieto[]>()
    for (const nakyma of LEMONATOR_NAKYMAT) {
      if (!ryhmaMap.has(nakyma.ryhma)) {
        ryhmaMap.set(nakyma.ryhma, [])
      }
      ryhmaMap.get(nakyma.ryhma).push(nakyma)
    }
    this.nakymaRyhmat = Array.from(ryhmaMap.entries()).map(([ryhma, nakymat]) => ({ ryhma, nakymat }))
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  ngOnInit() {
    // Debug thingies
    this.kirjanpitajaOnDevaajaObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable
    this.kirjanpitajaOnDevaajaTaiTukiObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaTaiTukiObservable
    this.kirjanpitajaUriObservable = this._route.data.pipe(
      map((route: { data: KirjanpitajaComponentData }) => {
        if (route?.data?.kirjanpitaja?.avain) {
          return 'kirjanpitajat/' + route?.data?.kirjanpitaja?.avain
        }
        return ''
      }),
    )
    this.kirjanpitajaEncodedUriObservable = this.kirjanpitajaUriObservable.pipe(
      map(uri => {
        return this._debugService.createFirestoreLink(uri)
      }),
    )

    this.kaikkiToimipisteet = this._kirjanpitajanToimipisteService.annaKaikkiToimipisteet()

    const injector = this._injector
    this.lomake = form(
      signal<KirjanpitajaLomake>({ etunimi: '', sukunimi: '', email: '', puhelin: '', aloitti: null, toimipiste: null, tutkintoKlt: false, aktiivinen: true, rooli: null }),
      polku => {
        required(polku.etunimi)
        required(polku.sukunimi)
        required(polku.email)
        validoiReaktiivisesti(polku.email, this.validateEmail)
        pattern(polku.puhelin, /^[\d ()+-]+$/)
        required(polku.aloitti)
        required(polku.toimipiste)
      },
      { injector },
    )

    // Bind to changes
    arvonMuutokset(this.lomake.etunimi, { injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        this.kirjanpitaja.etunimi = this._validationService.processValue(value)
      })
    arvonMuutokset(this.lomake.sukunimi, { injector }).subscribe(value => {
      this.kirjanpitaja.sukunimi = this._validationService.processValue(value)
    })
    arvonMuutokset(this.lomake.email, { injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        this.kirjanpitaja.email = this._validationService.processValue(value)
      })
    arvonMuutokset(this.lomake.puhelin, { injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        this.kirjanpitaja.puhelin = this._validationService.processValue(value)
      })
    arvonMuutokset(this.lomake.aloitti, { injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        this.kirjanpitaja.aloitti = this._validationService.processValue(this._dateService.dateToNumber(value))
      })
    arvonMuutokset(this.lomake.toimipiste, { injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        this.kirjanpitaja.toimipisteAvain = this._validationService.processValue(value)
      })
    arvonMuutokset(this.lomake.tutkintoKlt, { injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        if (!this.kirjanpitaja.tutkinnot) {
          this.kirjanpitaja.tutkinnot = {}
        }
        this.kirjanpitaja.tutkinnot.klt = value || false
      })
    arvonMuutokset(this.lomake.aktiivinen, { injector }).subscribe(value => {
      this.kirjanpitaja.poistettu = !value
    })

    this._route.data.pipe(takeUntil(this._ngUnsubscribe)).subscribe((data: Data) => {
      const componentData = data.data as KirjanpitajaComponentData
      nollaa(this.lomake, TYHJA_LOMAKE)
      this.kirjanpitaja = this._kirjanpitajaKopioija.kopioiKirjanpitaja(componentData.kirjanpitaja)
      this.alustaLomakkeenTiedot(this.kirjanpitaja)

      setTimeout(() => {
        if (this.etunimiInput) {
          this.etunimiInput.focus()
          this._changeDetectorRef.markForCheck()
        }
      }, 25)
    })

    this._dndService.isDraggingInWindowObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(dragging => {
      this.isDragging = dragging
    })
  }

  private validateEmail: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value == null || ctrl.value === undefined || ctrl.value.trim() === '') {
      return null
    }
    return Validators.email(ctrl)
  }

  private alustaLomakkeenTiedot(kirjanpitaja: Kirjanpitaja) {
    asetaArvo(this.lomake.etunimi, kirjanpitaja.etunimi ?? '')
    asetaArvo(this.lomake.sukunimi, kirjanpitaja.sukunimi ?? '')
    asetaArvo(this.lomake.email, kirjanpitaja.email ?? '')
    asetaArvo(this.lomake.puhelin, kirjanpitaja.puhelin ? kirjanpitaja.puhelin : '')
    asetaArvo(this.lomake.aloitti, this._dateService.numberToDate(kirjanpitaja.aloitti))
    asetaArvo(this.lomake.toimipiste, kirjanpitaja.toimipisteAvain ?? null)
    asetaArvo(this.lomake.tutkintoKlt, kirjanpitaja.tutkinnot?.klt || false)
    asetaArvo(this.lomake.aktiivinen, !kirjanpitaja.poistettu)
    this._lataaJaAsetaRooli(kirjanpitaja.avain)
  }

  private async _lataaJaAsetaRooli(uid: string) {
    const rooliKentta = this.lomake.rooli
    if (!uid) {
      nollaa(rooliKentta, null)
      return
    }
    try {
      const data = await this._firebaseLemonaid.firestoreDoc<KirjanpitajienRooliKonfiguraatio>(this._roolitUriService.annaKirjanpitajienRoolitUri()).get()
      const nykyinen = data?.roolit?.[uid] ?? null
      nollaa(rooliKentta, nykyinen)
    } catch (err) {
      // Lukuvirhe ei estä lomakkeen käyttöä — käyttäjä näkee tyhjän roolin, ja vain jos hän
      // muuttaa sitä lähetetään CF-kutsu. Lokitetaan kuitenkin Sentryyn.
      this._errorHandler.handleError(err)
      nollaa(rooliKentta, null)
    }
  }

  peruuta() {
    this._router.navigate(['yllapito', 'kirjanpitajat'])
  }

  private _saveRunning = false
  async save() {
    if (this._saveRunning) {
      return
    }
    try {
      this._saveRunning = true

      if (!this.lomake().valid()) {
        this._validationService.merkitseKokoLomakeKosketuksi(this.lomake)
        return
      }

      this._ladataanService.aloitaLataaminen()
      this.commonError.set(null)

      // Roolin muutos tehdään ensin, jotta tiimitarkistus epäonnistuu nopeasti ilman että muut
      // kentät on jo ehditty tallentaa.
      const rooliKentta = this.lomake.rooli
      if (rooliKentta().dirty()) {
        const onDevaajaTaiTuki = await firstValueFrom(this.kirjanpitajaOnDevaajaTaiTukiObservable)
        if (onDevaajaTaiTuki && this.kirjanpitaja.avain) {
          const pyynto: TallennaKirjanpitajanRooliPyynto = {
            uid: this.kirjanpitaja.avain,
            rooli: rooliKentta().value(),
          }
          const vastaus = await this._firebase.functionsCall<TallennaKirjanpitajanRooliPyynto, TallennaKirjanpitajanRooliVastaus>('roolitTallennaRooli', pyynto)
          if (vastaus?.e) {
            this.commonError.set('Roolin tallennus epäonnistui (' + vastaus.e + '). Muita muutoksia ei tallennettu.')
            return
          }
          rooliKentta().reset()
          this._snackbar.open('Roolin muutos tehoaa, kun kirjanpitäjä kirjautuu uudelleen sisään.', 'OK', { duration: 5000 })
        }
      }

      await this._kirjanpitajaService.paivitaKirjanpitaja(this.kirjanpitaja)

      // Luodaan uusi kirjanpitaja-olio ja alustetaan, jotta allekirjoitus yms. päivittyvät uusilla tiedoilla
      this.kirjanpitaja = this._kirjanpitajaKopioija.kopioiKirjanpitaja(this.kirjanpitaja)
      this.alustaLomakkeenTiedot(this.kirjanpitaja)
      this._changeDetectorRef.markForCheck()
    } catch (err: any) {
      this._errorHandler.handleError(err)
      this.commonError.set('Tallentamisen aikana tapahtui virhe. Ole hyvä ja ilmoita tästä ylläpidolle. Tekninen virhe: "' + err.message + '".')
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._saveRunning = false
    }
  }

  naytaVirhe<T>(kentta: FieldTree<T>, laji: string): boolean {
    const tila = kentta()
    return tila.errors().some(virhe => virhe.kind === laji) && (tila.dirty() || tila.touched())
  }

  // Tyhjä/undefined allowedViews tarkoittaa, että kaikki näkymät näytetään (rajoituksia ei ole).
  // Käytetään tätä apumetodia checkboxien renderöinnissä, jotta tallennettu tila pysyy tyhjänä
  // kun rajoituksia ei ole asetettu.
  onkoNakymaValittu(avain: LemonatorNakyma): boolean {
    if (!this.kirjanpitaja?.allowedViews || Object.keys(this.kirjanpitaja.allowedViews).length === 0) {
      return true
    }
    return !!this.kirjanpitaja.allowedViews[avain]
  }

  toggleNakyma(avain: LemonatorNakyma, checked: boolean) {
    // Jos lähdetään tyhjästä (= oletuksena kaikki näkyvissä), populoidaan täysrekisteri,
    // jotta ensimmäinen poisvalinta vaikuttaa eikä jää huomaamatta.
    if (!this.kirjanpitaja.allowedViews || Object.keys(this.kirjanpitaja.allowedViews).length === 0) {
      this.kirjanpitaja.allowedViews = kaikkiNakymatRecord()
    }
    if (checked) {
      this.kirjanpitaja.allowedViews[avain] = true
    } else {
      delete this.kirjanpitaja.allowedViews[avain]
    }
  }

  valitseKaikkiNakymat() {
    this.kirjanpitaja.allowedViews = kaikkiNakymatRecord()
  }

  poistaKaikkiNakymat() {
    this.kirjanpitaja.allowedViews = {}
  }

  tiedostoaLadataan: boolean = false
  tiedostoaKasitellaan: boolean = false

  public fileOver() {
    this._dndService.setDragging(true)
  }

  public fileLeave() {
    this._dndService.setDragging(true)
  }

  // Load start when drag 'n dropped
  public async fileDrop(entries: FileDropEntry[]): Promise<void> {
    this._dndService.setDragging(false)
    this.fileDropTiedostoToKuva(entries)
  }

  // Load start when clicked
  public lataa(event) {
    if (event.target.files) {
      const list: FileList = event.target.files
      const tiedostot: FileDropEntry[] = this._tiedostojenLataamisService.fileListToNgxFileDropEntries(list)
      if (tiedostot.length > 1) {
        this.kuvanVirhe = 'Lataa vain yksi kuva.'
      }
      this.fileDropTiedostoToKuva(tiedostot)
    }
  }

  private _annaMinimiPaivamaara<T>(kentta: FieldTree<T>): Date {
    if (!kentta().disabled()) {
      const d = new Date()
      d.setDate(1)
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      d.setMilliseconds(1)
      return this._dateService.lisaaKuukausia(d, 1)
    }
    return new Date(1980, 1, 1)
  }

  async fileDropTiedostoToKuva(tiedostot: FileDropEntry[]) {
    const tiedosto = tiedostot[0]

    const fileEnding = this._tiedostojenLataamisService.getFileEndingFromNgxFileDropEntry(tiedosto)

    if (fileEnding !== 'jpg' && fileEnding !== 'jpeg') {
      this.kuvanVirhe = 'Lataa kuva JPG-muodossa.'
    }

    this._ladataanService.aloitaLataaminen()

    const file = await this._tiedostojenLataamisService.getFile(tiedosto.fileEntry as FileSystemFileEntry)
    const tiedostonNimi = this.kirjanpitaja.etunimi.toLowerCase() + '.' + this.kirjanpitaja.sukunimi.toLowerCase() + '.' + this._firebase.firestoreCreateId() + '.' + fileEnding
    const fileDataUrl = await this._tiedostojenLataamisService.getAsDataUrl(file)

    const fileBase64 = fileDataUrl.replace('data:', '').replace(/^.+,/, '')

    const request: KirjanpitajanKuvanUploadRequest = {
      kirjanpitajanAvain: this.kirjanpitaja.avain,
      fileName: tiedostonNimi,
      fileBase64: fileBase64,
    }

    return this._firebase
      .functionsCall<KirjanpitajanKuvanUploadRequest, KirjanpitajanKuvanUploadResponse>('kirjanpitajanKuvaUploadAndConvert', request)
      .then(resp => {
        if (!resp || resp.e) {
          this._errorHandler.handleError(new Error(resp ? resp.e : 'unknown-error'))
          this._snackbar.open('Kuvan lataaminen epäonnistui, yritä uudelleen', 'OK', { duration: 5000 })
        } else {
          this._snackbar.open('Kuvan lataaminen onnistui', 'OK', { duration: 5000 })
        }
      })
      .finally(() => {
        this._ladataanService.lopetaLataaminen()
      })
  }

  async katkaiseLemonatorSessio() {
    const data: AreYouSureDialogData = {
      text: 'Haluatko varmasti katkaista kirjanpitäjän Lemonator-sessiot? Tämä kirjaa hänet automaattisesti ulos Lemonatorista.',
      rightAction: 'Kyllä',
    }

    const isSure = await firstValueFrom(this._dialog.open<AreYouSureDialog, AreYouSureDialogData>(AreYouSureDialog, { data: data }).afterClosed())
    if (!isSure) {
      return
    }

    try {
      const resp = await this._firebase.functionsCall<KatkaiseKirjanpitajanSessioPyynto, KatkaiseKirjanpitajanSessioVastaus>('kirjanpitajanSessioKatkaise', {
        kirjanpitajanAvain: this.kirjanpitaja.avain,
      })
      if (!resp || resp.e) {
        this._snackbar.open('Kirjanpitäjän session katkaiseminen epäonnistui', 'OK', { duration: 5000 })
      } else {
        this._snackbar.open('Kirjanpitäjän sessio katkaistiin onnistuneesti', 'OK', { duration: 5000 })
      }
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }
}
